/*
 * @Author: Teemo Ding
 * @Date: 2021-08-27 15:29:05
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2021-08-30 09:40:10
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelProductsConfig/SalesChannelProductCustomization/CustomisationButton/index.tsx
 */
import { Input } from '@/src/components/Antd';
import ItemWrapper from '@/src/constrains/SalesChannelPreviewPageComponents/OverwriteItemWrapper';
import Section from '@/src/constrains/SalesChannelPreviewPageComponents/SectionContainer';
import React from 'react';
import { useDispatch } from 'react-redux';
import ColorPicker from 'src/components/ColorPicker/ColorPicker';
import { store } from 'src/store';
import {
  EnumCollapseId,
  getCollapseOpenStatus,
  getCollapseValidationMsgDisplay,
  getCustomisationButton,
  getSubmitStamp,
  onCollapseOpen,
  onCustomisationButtonChange,
  onCustomisationButtonReset,
  onErrorChange,
} from '../slice';
import { validateCustomisationButton } from '../tools';

import ErrorProcessingHOC from 'src/constrains/SalesChannelPreviewPageComponents/ErrorProcessingHOC';
import { useI18n } from 'src/hooks/useRouterChange';
import { getI18nFromGeneral, i18nGet } from 'src/tools/tools';
export const suffix = 'saleChannelLinkProductCustomization';
const idSet = {
  outlineColour: suffix + 'outlineColour',
  textColour: suffix + 'textColour',
};
const CustomisationButton = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { data, isPrimary, specificError, disabled } = props;
  const { textError = [] } = specificError;

  const { text, outlineColour, textColour } = data || {};

  const _d = useDispatch();
  const handleOnOutlineChange = (outlineColour) => {
    _d(onCustomisationButtonChange({ outlineColour }));
  };

  const handleOnTextColorChange = (textColour) => {
    _d(onCustomisationButtonChange({ textColour }));
  };
  const handleOnTextChange = (text) => {
    _d(onCustomisationButtonChange({ text }));
  };
  return (
    <React.Fragment>
      <Section>
        <ItemWrapper title={`${getI18n('general.buttonText')}*`}>
          <Input
            size='large'
            error={textError.length}
            help={textError[0]}
            value={text}
            disabled={disabled}
            onChange={handleOnTextChange}
            placeholder={getI18n(
              'salesChannelProductCustomization.index.pleaseinputbuttontext',
            )}
          />
        </ItemWrapper>
        {isPrimary && (
          <ItemWrapper
            id={idSet.outlineColour}
            title={getI18n(
              'salesChannelProductCustomization.index.outlineColour',
            )}>
            <ColorPicker
              id={idSet.outlineColour}
              onChange={handleOnOutlineChange}
              multi
              color={outlineColour}
              disable={disabled}
            />
          </ItemWrapper>
        )}
        {isPrimary && (
          <ItemWrapper
            id={idSet.textColour}
            title={getI18n('general.textColour')}>
            <ColorPicker
              onChange={handleOnTextColorChange}
              multi
              id={idSet.textColour}
              color={textColour}
              disable={disabled}
            />
          </ItemWrapper>
        )}
      </Section>
    </React.Fragment>
  );
};

export default ErrorProcessingHOC(CustomisationButton, {
  getCollapseOpenStatus,
  onCollapseOpen,
  id: EnumCollapseId.customisationButton,
  getContent: getCustomisationButton,
  title: getI18nFromGeneral('general.hOCTitle.customisationButton'),
  getErrorDisplay: getCollapseValidationMsgDisplay,
  onErrorChange,
  headerProps: {
    dotsFunction: [
      {
        onClick: () => {
          store.dispatch(onCustomisationButtonReset());
        },
        key: 'Reset',
        body: getI18nFromGeneral('general.hOCTitle.reset'),
        isDangerous: true,
      },
    ],
    hasDots: true,
    hideDotsWhenNotPrimary: true,
  },
  validation: (x, validationProps) => {
    const { isPrimary } = validationProps || {};

    return validateCustomisationButton(x, isPrimary);
  },
  getSubmitStamp,
});
